import React, { DragEventHandler } from 'react';
import TimelinePlayer from '../../components/TimelinePlayer';
import { SubtitleStyle } from '../../types';
import { Upload } from 'lucide-react';
import type {
  ProCurrentScope,
  ProHandleClipSelect,
  ProHandleSubtitleClick,
  ProHandleTranslateSubtitles,
  ProNavigateIntoClip,
  ProTimelinePlayerRef,
} from '../types/editor';

interface ProPreviewCanvasProps {
  isInitialDropzoneVisible: boolean;
  isDragOver: boolean;
  onDragOver: DragEventHandler<HTMLDivElement>;
  onDragLeave: DragEventHandler<HTMLDivElement>;
  onDrop: DragEventHandler<HTMLDivElement>;
  onInitialFilesDrop: (files: File[]) => void;
  timelinePlayerRef: React.MutableRefObject<ProTimelinePlayerRef | null>;
  currentScope: ProCurrentScope;
  selectedClipId: string | null;
  onClipSelect: ProHandleClipSelect;
  subtitleStyle: SubtitleStyle;
  activeSubtitleLanguage: string;
  onActiveSubtitleLanguageChange: (lang: string) => void;
  onTranslateSubtitles: ProHandleTranslateSubtitles;
  onSubtitleClick: ProHandleSubtitleClick;
  onNavigateInto: ProNavigateIntoClip;
}

export const ProPreviewCanvas: React.FC<ProPreviewCanvasProps> = ({
  isInitialDropzoneVisible,
  isDragOver,
  onDragOver,
  onDragLeave,
  onDrop,
  onInitialFilesDrop,
  timelinePlayerRef,
  currentScope,
  selectedClipId,
  onClipSelect,
  subtitleStyle,
  activeSubtitleLanguage,
  onActiveSubtitleLanguageChange,
  onTranslateSubtitles,
  onSubtitleClick,
  onNavigateInto,
}) => {
  return (
    <div
      className="pro-preview"
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {isInitialDropzoneVisible ? (
        <div className={`pro-dropzone ${isDragOver ? 'drag-over' : ''}`}>
          <div className="pro-dropzone__border" />
          <Upload className="pro-dropzone__icon" />
          <div className="pro-dropzone__text">Deposez vos fichiers ici</div>
          <div className="pro-dropzone__hint">Video, audio, images ou cliquez pour parcourir</div>
          <input
            type="file"
            multiple
            accept="video/*,audio/*,image/*"
            className="absolute inset-0 opacity-0 cursor-pointer"
            onChange={(e) => {
              const files = Array.from(e.target.files || []);
              if (files.length > 0) onInitialFilesDrop(files);
            }}
          />
        </div>
      ) : (
        <div className="pro-preview__canvas">
          <div className="pro-preview__video-container">
            <TimelinePlayer
              ref={timelinePlayerRef}
              clips={currentScope.clips}
              tracks={currentScope.tracks}
              selectedClipId={selectedClipId}
              onClipSelect={onClipSelect}
              subtitleStyle={subtitleStyle}
              activeSubtitleLanguage={activeSubtitleLanguage}
              onActiveSubtitleLanguageChange={onActiveSubtitleLanguageChange}
              onTranslateSubtitles={onTranslateSubtitles}
              onSubtitleClick={onSubtitleClick}
              onNavigateInto={onNavigateInto}
              backgroundColor={currentScope.syntheData?.backgroundColor}
              isCompact={false}
            />
          </div>
        </div>
      )}
    </div>
  );
};
